import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { useEffect, useState } from "react";
import { gathDataExcelDownLoad } from "../../../service/log/elderLogService";
import { IntlProvider, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import { roundNum } from "../../../com/dataUtil";

// css
import styles from './elderLog.module.css';


const ElderLogGrid = ({ dataSource, page, setPageValue, search, infoEventWindow, setInfoEventWindow, setLoading }) => {
  // 데이터 세팅
  const gridDs = dataSource.gridDs;
  const total = dataSource.total;
  const bizType = gridDs.length ? gridDs[0].bizType : "";

  // 이벤트 안내 창 상태
  // const [infoEventFl , setInfoEventFl] = useState(false);

  // 엑셀 다운로드 이벤트
  const excelDown = () => {
    setLoading(true);
    gathDataExcelDownLoad(search, setLoading);
  };

  // 엑셀 다운로드 reject
  const excelDownRejection = error => {};

  // 헤더 템플릿
  const dataStatHeaderCell = e => {
    return (
      <div>
        상태
        <span onMouseOver={mounseOverEvt} onMouseOut={mounseOutEvt}>
          <img id="info" src="/images/info.png"></img>
        </span>
      </div>
    );
  };

  // 이벤트 마우스 오버 이벤트 안내창
  const mounseOverEvt = () => {
    setInfoEventWindow(true);
  };

  // 이벤트 마우스 아웃 이벤트 안내창
  const mounseOutEvt = () => {
    setInfoEventWindow(false);
  };

  // 온도 컬럼 값 포맷 설정
  const temperatureCellTemplate = v => {
    
    let temperature = v.dataItem.temperature;

    if(v.dataItem.bizType === "5003") {
      temperature = temperature - 5;
    }
    return <td>{roundNum(temperature, 1)}</td>
  }

  // 습도 컬럼 값 포맷 설정
  const humidityCellTemplate = v => {
    
    let humidity = v.dataItem.humidity;

    if(v.dataItem.bizType === "5003") {
      humidity = humidity + 10;
    }
    return <td>{roundNum(humidity, 1)}</td>
  }

  // 이벤트 컬럼 값 포맷 설정
  const dataStatSctCellTemplate = v => {
    const dataStatCode = v.dataItem.dataStatSctCodeNo;
    const dataStatSctTerm = v.dataItem.dataStatSctCodeVal;
    let imgSrc = "";
    if (dataStatCode === 10001) {
      imgSrc = "/images/chncareimg/icon_rd.png";
    } else if (dataStatCode === 10002) {
      imgSrc = "/images/chncareimg/icon_yl.png";
    } else if (dataStatCode === 10003) {
      imgSrc = "/images/chncareimg/icon_gre.png";
    }
    // 숙면= 수면으로 통합
    else if (dataStatCode === 10004) {
      imgSrc = "/images/chncareimg/icon_gre.png";
    } else if (dataStatCode === 10005) {
      imgSrc = "/images/chncareimg/icon_bl.png";
    } else if (dataStatCode === 10006) {
      imgSrc = "/images/chncareimg/icon_yyl.png";
    } else {
      imgSrc = "/images/chncareimg/icon_gray.png";
    }
    return (
      <td>
        <img style={{ width: "13px", marginTop: "-3px" }} src={imgSrc}></img> {dataStatSctTerm}
      </td>
    );
  };

  const eventCellTemplate = e => {
    if(e.dataItem.eventType === 11001) {
      const id = document.getElementById(e.id);
      return <td style={{ color: "#fff", background: "linear-gradient(#c73e3c, #e3615f)", fontWeight: "500"}}>{e.dataItem.eventTypeTerm}</td>
    } else {
      return <td>{e.dataItem.eventTypeTerm}</td>
    }
  }

  return (
    <div className={styles.elderLogGrid}>
      <LocalizationProvider language="ko-KR">
        <IntlProvider locale="ko">
          <Grid
            className={styles.grid}
            style={{ height: "100%" }}
            data={gridDs}
            total={total}
            skip={page.skip}
            take={page.take}
            onPageChange={setPageValue}
            page={page}
            pageable>
            <GridNoRecords>{dataSource.gridNoMessage}</GridNoRecords>
            <GridColumn title="일시" field="gathDtm" width="200px" />
            <GridColumn title="성함" field="userTerm" width="150px" />
            <GridColumn title="상태" field="dataStatSctTerm" cell={dataStatSctCellTemplate} width="130px" />
            <GridColumn title="움직임 (보정)" field="movement" width="150px"/>
            <GridColumn title="움직임 (수집)" field="movementPure" width="150px"/>
            <GridColumn title="속도" field="velocityTotal" width="150px"/>
            <GridColumn title="온도 (°C)" field="temperature" width="150px" cell={temperatureCellTemplate}/>
            <GridColumn title="습도 (%)" field="humidity" width="150px" cell={humidityCellTemplate}/>
            <GridColumn title="Co2 (ppm)" field="co2" width="150px"/>
            <GridColumn title="TVOC (ppb)" field="tvoc" width="150px"/>
            <GridColumn title="조도 (Lx)" field="light" width="150px"/>
            <GridColumn title="발생이벤트" field="eventTypeTerm" cell={eventCellTemplate}/>
          </Grid>
        </IntlProvider>
      </LocalizationProvider>
    </div>
    // <span className="elderLogRightContent">
    //   <div className="elderLogDivHeader">
    //     <h3 className="elderLogDivHeaderCont">
    //       데이터 수집이력
    //       <Button icon="excel" className="dataGathExcelDownBtn" onClick={excelDown}>
    //         엑셀저장
    //       </Button>
    //     </h3>
    //   </div>
    //   <div className="gathDataGridDiv">
    //     <LocalizationProvider language="ko-KR">
    //       <IntlProvider locale="ko">
    //         <Grid
    //           className="gathDataGrid"
    //           style={{ height: "100%" }}
    //           data={gridDs}
    //           total={total}
    //           skip={page.skip}
    //           take={page.take}
    //           onPageChange={setPageValue}
    //           page={page}
    //           pageable>
    //           <GridNoRecords>{dataSource.gridNoMessage}</GridNoRecords>
    //           <GridColumn title="일시" field="gathDtm" width="130px" />
    //           <GridColumn title="성함" field="userTerm" />
    //           <GridColumn title="상태" field="dataStatSctTerm" cell={dataStatSctCellTemplate} width="110px" headerCell={dataStatHeaderCell} />
    //           <GridColumn title="움직임(보정)" field="movement" width="100px"/>
    //           <GridColumn title="움직임(수집)" field="movementPure" width="100px"/>
    //           <GridColumn
    //             title="온도(°C)"
    //             field="temperature"
    //             cell={temperatureCellTemplate}
    //             headerCell={() => {
    //               return (
    //                 <div>
    //                   온도<br></br>(°C)
    //                 </div>
    //               );
    //             }}
    //           />
    //           <GridColumn
    //             title="습도(%)"
    //             field="humidity"
    //             headerCell={() => {
    //               return (
    //                 <div>
    //                   습도<br></br>(%)
    //                 </div>
    //               );
    //             }}
    //           />
    //           <GridColumn
    //             title="Co2(ppm)"
    //             field="co2"
    //             headerCell={() => {
    //               return (
    //                 <div>
    //                   Co2<br></br>(ppm)
    //                 </div>
    //               );
    //             }}
    //           />
    //           <GridColumn title="조도" field="light" />
    //           {/* <GridColumn title="발생이벤트" field="eventTypeTerm" /> */}
    //         </Grid>
    //       </IntlProvider>
    //     </LocalizationProvider>
    //   </div>
    //   {infoEventWindow === true && (
    //     <div className="infoEvent">
    //       {bizType === "5002" ? (
    //         <span className="infoEventContent">
    //           <b>
    //             <div style={{ textAlign: "center" }}>
    //               <b>
    //                 2차 설치제품 대상자 <br></br>
    //               </b>
    //             </div>
    //           </b>
    //           <b>
    //             {"<"}상태{">"}
    //           </b>
    //           <br />
    //           - 고활동 : 30분 이상, 움직임이 30 이상 측정되는 경우
    //           <br />
    //           - 저활동 : 30분 미만, 움직임이 30 이상 측정되는 경우
    //           <br />
    //           - 식사 :움직임이 50 이상, CO<small>2</small>가 1500 이상, 조도가 11 이상으로 측정되는 경우
    //           <br />
    //           - 부재 : 움직임이 30 미만으로 측정되는 경우
    //           <br />
    //           - 수면 : 움직임이 50 미만, 조도가 10 이하로 측정되는 경우
    //           <br />
    //           <br />※ 움직임 50 미만은 오차범위이므로 부재로 측정됩니다.
    //         </span>
    //       ) : (
    //         ""
    //       )}
    //       {bizType === "5001" ? (
    //         <span>
    //           <b>
    //             <div style={{ textAlign: "center", fontSize: "16px" }}>
    //               <b>
    //                 1차 설치제품 대상자 <br></br>
    //               </b>
    //             </div>
    //           </b>
    //           <b>
    //             {"<"}상태{">"}
    //           </b>
    //           <br />
    //           - 고활동 : 30분 이상, 움직임이 30 이상 측정되는 경우
    //           <br />
    //           - 저활동 : 30분 미만, 움직임이 30 이상 측정되는 경우
    //           <br />
    //           - 부재 : 움직임이 30 미만으로 측정되는 경우
    //           <br />
    //           {/* - 수면 : 30분 안에 호흡감지 데이터(움직임0)만 감지되거나 움직임 감지 데이터(호흡0) 수 보다 많은 경우
    //         <br /> */}
    //         </span>
    //       ) : (
    //         ""
    //       )}
    //       {!bizType ? (
    //         <>
    //           <span>
    //             <br />
    //             <div style={{ textAlign: "center", fontSize: "16px" }}>
    //               <b>
    //                 1차 설치제품 대상자 <br></br>
    //               </b>
    //             </div>
    //             <b>
    //               {"<"}상태{">"}
    //             </b>
    //             <br />
    //           - 고활동 : 30분 이상, 움직임이 30 이상 측정되는 경우
    //           <br />
    //           - 저활동 : 30분 미만, 움직임이 30 이상 측정되는 경우
    //           <br />
    //           - 부재 : 움직임이 30 미만으로 측정되는 경우
    //             <br />
    //             {/* - 수면 : 30분 안에 호흡감지 데이터(움직임0)만 감지되거나 움직임 감지 데이터(호흡0) 수 보다 많은 경우
    //   <br /> */}
    //           </span>
    //           <span className="infoEventContent">
    //             <b>
    //               <div style={{ textAlign: "center", fontSize: "16px" }}>
    //                 <b>
    //                   <br></br>
    //                   2차 설치제품 대상자 <br></br>
    //                 </b>
    //               </div>
    //             </b>
    //             <b>
    //               {"<"}상태{">"}
    //             </b>
    //             <br />
    //             - 고활동 : 30분 이상, 움직임이 30 이상 측정되는 경우
    //             <br />
    //             - 저활동 : 30분 미만, 움직임이 30 이상 측정되는 경우
    //             <br />
    //             - 식사 :움직임이 50 이상, CO<small>2</small>가 1500 이상, 조도가 11 이상으로 측정되는 경우
    //             <br />
    //             - 부재 : 움직임이 30 미만으로 측정되는 경우
    //             <br />
    //             - 수면 : 움직임이 50 미만, 조도가 10 이하로 측정되는 경우
    //             <br/>
    //             <br />※ 움직임 50 미만은 오차범위이므로 부재로 측정됩니다.
    //           </span>
    //         </>
    //       ) : (
    //         ""
    //       )}
    //     </div>
    //   )}
    // </span>
  );
};

export default ElderLogGrid;
